define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/aspect",
    "csi",
    "csi/def",
    "csi/def/Field",
    "csi/locale"
], function(declare,lang,aspect,csi,def,Field,locale) {
    var CANDIDATE_QTY = "CandidateQuantity";
    var IS_STYLE_CANDIDATE = "IsStyleCandidate";

    return declare(null, {

        _insertCandidateFields: function(/*csi.view.Widget*/view) {
            this.styleForm = view;
            aspect.after(view, "_updateFieldVisibility", function() {
                view.setFieldHidden(CANDIDATE_QTY, !view.getFieldValue(IS_STYLE_CANDIDATE));
            });

            view.insertField(lang.mixin(new Field(), {
                m_id: CANDIDATE_QTY,
                m_typeControl: def.FIELD_TEXT,
                m_onChange: lang.hitch(this, this._onChangeQuantity),
                m_onValidate: lang.hitch(this, this._onValidateQuantity)
            }), 0, true);

            view.insertField(lang.mixin(new Field(), {
                m_id: IS_STYLE_CANDIDATE,
                m_typeControl: def.FIELD_CHECKBOX,
                m_onChange: lang.hitch(this, this._onChangeCandidate)
            }), 0, true);

            // default to StyleCandidate creation if parent.Style is set or undefined
            if (this.getParent().Style != csi.EMPTY_URL) {
                view.addDefaultValue(IS_STYLE_CANDIDATE, false);
                view.addDefaultValue(CANDIDATE_QTY, 1);
            }
        },

        _onChangeCandidate: function(/*def.View*/defView, /*Field*/field, /*Any*/value) {
            // summary: set visibility and initial value of quantity field
            var qtyField = defView.getField(CANDIDATE_QTY);

            if (value && !!this.styleForm.getFieldValue(qtyField) == false)
                this.styleForm.setFieldValue(qtyField, 1);
        },

        _onChangeQuantity: function(defView, field, value) {
    		this.styleForm._setActionButtonsDisabled(false);
    	},

        _onValidateQuantity: function(/*def.View*/defView, /*Field*/field, /*Any*/value, /*Object*/params) {
            // summary: validate quantities making sure they are between 1 and 10
            var qty = Number(value);

            if (isNaN(qty) || qty < 1 || qty > 10)
                throw new Error(locale.resource("CreateStyleCandidateInvalidQuantity"));
        },

        /**
         * @override
         * Disable Save & Go since action can create multiple styles if Style Candidates qty is more than 1
         */
        _canNavigate: function() {
            return false;
        }
    });
});